<div class="wizard-integrations">
  <section class="wizard-section">
    <div class="wizard-integrations-top-row">
      <h5 class="wizard-heading-1">{{ "integrations" | translation }}</h5>
    </div>
    <div class="wizard-content">
      <p>
        {{
          "please_set_up_the_integration_to_your_canvas_instance_lingo"
            | translation
        }}
      </p>
      <ul style="padding-left: 17px">
        <li>
          {{ "integration_url_wizard_lingo" | translation }}
        </li>
        <li>{{ "friendly_name_wizard_lingo" | translation }}</li>
        <li>
          {{ "utility_account_wizard_account" | translation }}
        </li>
      </ul>
      <p>
        {{ "once_all_fields_have_been_populated_wizard_lingo" | translation }}
      </p>
    </div>
  </section>
  <section class="wizard-section">
    <app-wizard-integration-create></app-wizard-integration-create>
  </section>
  <section class="wizard-section">
    <app-wizard-integrations-list></app-wizard-integrations-list>
  </section>
</div>
